import ModelFrame from './ModelFrame.component';

export default ModelFrame;
